import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenis: Lenis | null = null;

export const getLenis = () => lenis;

// One global instance on the native document scroll, driven by GSAP's ticker (same frame as ScrollTrigger)
export function initSmoothScroll() {
  if (lenis || typeof window === 'undefined') return () => undefined;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return () => undefined;

  const instance = new Lenis({
    lerp: 0.09,
    wheelMultiplier: 1,
    smoothWheel: true,
    syncTouch: false,
  });
  lenis = instance;

  const onScroll = () => ScrollTrigger.update();
  instance.on('scroll', onScroll);
  const tick = (time: number) => instance.raf(time * 1000);
  gsap.ticker.add(tick);
  gsap.ticker.lagSmoothing(0);

  return () => {
    gsap.ticker.remove(tick);
    instance.destroy();
    lenis = null;
  };
}

export function scrollToTop() {
  if (lenis) lenis.scrollTo(0, { immediate: true, force: true });
  else window.scrollTo(0, 0);
}

export function scrollToEl(el: HTMLElement) {
  if (lenis) lenis.scrollTo(el, { immediate: true, force: true });
  else el.scrollIntoView({ behavior: 'auto', block: 'start' });
}